export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002',
  TIMEOUT: 30000,
  UPLOAD_TIMEOUT: 120000,
};

export const APP_CONFIG = {
  NAME: process.env.REACT_APP_APP_NAME || 'RRMS',
  FULL_NAME:
    process.env.REACT_APP_APP_FULL_NAME || 'Records & Room Management System',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  NOTIFICATION_POLL_INTERVAL: parseInt(
    process.env.REACT_APP_NOTIFICATION_POLL_INTERVAL || '30000',
    10
  ),
};

